import React from 'react';
import { Box } from '@honda-canada/design-system-react';

import themeStyles from './styles/Details.styles';

const ToggleWrapper = themeStyles.apply(Box, 'ToggleWrapper');
const ToggleIndicator = themeStyles.apply(Box, 'ToggleIndicator');
const AriaSwitchText = themeStyles.apply(Box, 'AriaSwitchText');

const Toggle = ({ on, onClick, onText = 'on', offText = 'off', isDark, toggleAriaLabel }) => (
  <ToggleWrapper
    onClick={onClick}
    role="switch"
    data-testid="cy-toggle"
    aria-checked={on}
    onKeyDown={e => e.key === 'Enter' && onClick()}
    aria-label={toggleAriaLabel}
  >
    <ToggleIndicator isDark={isDark} tabIndex="0" on={on.toString()} />
    <AriaSwitchText aria-hidden="true">{onText}</AriaSwitchText>
    <AriaSwitchText aria-hidden="false">{offText}</AriaSwitchText>
  </ToggleWrapper>
);

export default Toggle;
